import type { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import { getOrganizationId } from '@core-mkt/services/schema/organization.schema';

/**
 * The single-review component renders one hardcoded testimonial in its template.
 * If the markup ever changes, update this constant to match.
 */
export const SINGLE_REVIEW_CONTENT = {
  reviewBody: 'I love Aceable I was able to do it whenever and wherever after school or after practice.',
  authorName: 'Iliana B.',
  authorLocation: 'San Antonio, TX',
};

export interface SingleReviewSchemaData {
  pageUrl: string;
  siteUrl: string;
  organizationName: string;
}

/**
 * Returns a Schema.org Review node for the single-review component's hardcoded testimonial.
 * The review has no rating (it is a marketing testimonial), so `reviewRating` is omitted.
 * `itemReviewed` cross-references the page's Organization @id so the testimonial is tied
 * to the brand.
 */
export function getSingleReviewSchema(data: SingleReviewSchemaData | null): SchemaOrgNode | null {
  if (!data || !data.pageUrl || !data.siteUrl || !data.organizationName) return null;

  return {
    '@type': 'Review',
    '@id': `${data.pageUrl}#single-review`,
    author: { '@type': 'Person', name: SINGLE_REVIEW_CONTENT.authorName },
    reviewBody: SINGLE_REVIEW_CONTENT.reviewBody,
    itemReviewed: {
      '@id': getOrganizationId(data.siteUrl),
      '@type': 'EducationalOrganization',
      name: data.organizationName,
    },
  };
}
